<div id="content">
  <app-company-product-page-identity title="Monitores de estado"></app-company-product-page-identity>

  @if (can_configure_notifiables() && has_bot_not_member_conversation()) {
    <div class="bot-membership-warning" role="status">
      <mat-icon aria-hidden="true">warning</mat-icon>
      <p>
        Hay conversaciones de alerta (o el canal interno) donde el bot de Bisual no está añadido. Sin eso no se enviarán avisos de
        monitores. Invita al bot al canal en Slack.
      </p>
    </div>
  }

  @if (serialized_monitors().length === 0) {
    <section class="empty-state">
      <mat-icon aria-hidden="true">monitor_heart</mat-icon>
      <p>Este producto no tiene monitores de uptime configurados.</p>
    </section>
  } @else {
    <div class="monitors-list">
      @for (row of serialized_monitors(); track row.monitor.id) {
        <section class="monitor-card" [class.monitor-card--inactive]="!row.monitor.is_active">
          <header class="monitor-card-header">
            <div class="monitor-card-title">
              <mat-icon aria-hidden="true">monitor_heart</mat-icon>
              <h2>Monitor {{ row.monitor_id_label }}</h2>
              <span class="status-pill" [class]="'status-pill--' + row.status_class">{{ row.status_label }}</span>
              <span class="meta-pill">{{ row.is_active_label }}</span>
            </div>
            @if (can_configure_notifiables()) {
              <button mat-stroked-button type="button" (click)="openConfigureDialog(row.monitor)">
                <mat-icon>notifications</mat-icon>
                Destinatarios
              </button>
            }
          </header>

          <div class="monitor-meta">
            <span>{{ row.exec_interval_label }}</span>
            <span>{{ row.endpoints_count_label }}</span>
          </div>

          <div class="notifiables-block">
            <div class="notifiables-label">Destinatarios de alertas</div>
            @if (!row.has_any_notifiables) {
              <p class="notifiables-empty">Sin destinatarios automáticos ni configurados</p>
            } @else {
              @if (row.default_notifiables.length > 0) {
                <div class="notifiables-subsection-label">Automáticos</div>
                <ul class="notifiables-list">
                  @for (item of row.default_notifiables; track item.kind + '-' + item.id) {
                    <li>
                      <mat-icon aria-hidden="true">{{ item.kind === 'user' ? 'person' : 'forum' }}</mat-icon>
                      <span class="notifiable-name">{{ item.label }}</span>
                      <span class="notifiable-reason-chip">{{ item.reason_label }}</span>
                    </li>
                  }
                </ul>
              }

              @if (row.has_configured_notifiables) {
                <div class="notifiables-subsection-label">Adicionales</div>
                <ul class="notifiables-list">
                  @for (user of row.user_notifiables; track user.id) {
                    <li>
                      <mat-icon aria-hidden="true">person</mat-icon>
                      <span class="notifiable-name">{{ formatUserLabel(user) }}</span>
                    </li>
                  }
                  @for (conversation of row.messaging_conversations; track conversation.id) {
                    <li>
                      <mat-icon aria-hidden="true">forum</mat-icon>
                      <span class="notifiable-name">{{ formatMessagingConversationLabel(conversation) }}</span>
                    </li>
                  }
                </ul>
              }
            }
          </div>
        </section>
      }
    </div>
  }
</div>
